module.exports = __webpack_public_path__ + "static/img/48651.0588f4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48651.jpg
// module id = TGTf
// module chunks = 1